import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import { getCalendarCapWarningText } from '../../../Calendar.utils'

export function getCalendarTaskMoveDayLoadWarning({ dayLoad, locale, t }) {
  return [
    getCalendarCapWarningText({ dayLoad, locale, t }),
    t('Calendar.MoveTasksDontCountKey'),
  ].join(CHARACTER_WHITESPACE)
}
